import React from 'react';
import LandingFaqItem from 'app/components/landing_components/LandingFaqItem';

interface Props {
    landingName: string;
    numberOfQuestions: number;
}

const faqList = (landingName: string, numberOfQuestions: number) => Array.from({length: numberOfQuestions}, (_, i) => ({
    a: `${landingName}.faq_title_${i + 1}`,
    q: `${landingName}.faq_description_${i + 1}`
}));

const LandingFaq: React.FC<Props> = ({landingName, numberOfQuestions}) => <div className="landing-promo-faq-list">
    {faqList(landingName, numberOfQuestions).map((faqItem, id) => <LandingFaqItem faqItem={faqItem} key={id}/>)}
</div>;

export default LandingFaq;
